// Manual de uso: una sección por archivo .md de esta carpeta (viajan con cada
// versión de epms). `rutas` dice qué pantallas abre el botón "?" en esa
// sección. Una pantalla nueva del menú tiene que tener su sección: lo controla
// scripts/verificar-ayuda.ts (corre con npm test).
import archivos from './archivos.md?raw';
import bandeja from './bandeja.md?raw';
import cintas from './cintas.md?raw';
import clientes from './clientes.md?raw';
import conciliar from './conciliar.md?raw';
import configuracion from './configuracion.md?raw';
import cumplimiento from './cumplimiento.md?raw';
import informeMensual from './informe-mensual.md?raw';
import miCuenta from './mi-cuenta.md?raw';
import miDia from './mi-dia.md?raw';
import primerosPasos from './primeros-pasos.md?raw';
import sincronizacion from './sincronizacion.md?raw';
import vencimientos from './vencimientos.md?raw';

export interface Seccion {
  id: string;
  titulo: string;
  /** Rutas (prefijos) de las pantallas que explica. */
  rutas: string[];
  texto: string;
}

export const SECCIONES: Seccion[] = [
  { id: 'primeros-pasos', titulo: 'Primeros pasos', rutas: [], texto: primerosPasos },
  { id: 'mi-dia', titulo: 'Mi día', rutas: ['/inicio'], texto: miDia },
  { id: 'cintas', titulo: 'Cintas rojas', rutas: [], texto: cintas },
  { id: 'clientes', titulo: 'Clientes y su ficha', rutas: ['/clientes'], texto: clientes },
  { id: 'informe-mensual', titulo: 'Informe mensual', rutas: [], texto: informeMensual },
  { id: 'archivos', titulo: 'Archivos y antivirus', rutas: [], texto: archivos },
  { id: 'bandeja', titulo: 'Bandeja de mail', rutas: ['/bandeja'], texto: bandeja },
  { id: 'vencimientos', titulo: 'Vencimientos', rutas: ['/vencimientos'], texto: vencimientos },
  { id: 'conciliar', titulo: 'Conciliar', rutas: ['/conciliar'], texto: conciliar },
  { id: 'cumplimiento', titulo: 'Cumplimiento', rutas: ['/cumplimiento'], texto: cumplimiento },
  { id: 'sincronizacion', titulo: 'Sincronización con ARCA', rutas: ['/sincronizacion'], texto: sincronizacion },
  { id: 'mi-cuenta', titulo: 'Mi cuenta y clave fiscal', rutas: ['/mi-cuenta'], texto: miCuenta },
  { id: 'configuracion', titulo: 'Configuración', rutas: ['/config'], texto: configuracion },
];

/** La sección que explica la pantalla `pathname` (la de prefijo más largo); si no hay, Primeros pasos. */
export function seccionDeRuta(pathname: string): string {
  let mejor = { id: 'primeros-pasos', largo: 0 };
  for (const s of SECCIONES) {
    for (const r of s.rutas) {
      if ((pathname === r || pathname.startsWith(r + '/')) && r.length > mejor.largo) mejor = { id: s.id, largo: r.length };
    }
  }
  return mejor.id;
}
